<template>
  <div>
    <el-dialog
      ref="addEditDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h660_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditForm"
          :model="dialogAddEditForm"
          :rules="eventType==='view' ? null : dialogAddEditFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                  >
                    <el-input
                      v-model="dialogAddEditForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="城市"
                  >
                    <el-input
                      v-model="dialogAddEditForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="终端名称"
                  >
                    <el-input
                      v-model="dialogAddEditForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="联系人"
                  >
                    <el-input
                      v-model="dialogAddEditForm.linkman"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="联系电话"
                  >
                    <el-input
                      v-model="dialogAddEditForm.phone"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案编号"
                  >
                    <el-input
                      v-model="dialogAddEditForm.schemeNo"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="方案名称"
                  >
                    <el-input
                      v-model="dialogAddEditForm.schemeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="物料发放人"
                  >
                    <el-input
                      v-model="dialogAddEditForm.materialsOperater"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="发放时间"
                  >
                    <el-input
                      v-model="dialogAddEditForm.issueDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="发放物料名称"
                  >
                    <el-input
                      v-model="dialogAddEditForm.materialsName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="单位"
                  >
                    <el-input
                      v-model="dialogAddEditForm.unitName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="发放数量"
                  >
                    <el-input
                      v-model="dialogAddEditForm.amount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访人"
                  >
                    <el-input
                      v-model="dialogAddEditForm.callBackUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访时间"
                    prop="callBackDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditForm.callBackDate"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期"
                      style="width: 100%;"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访方式"
                    prop="callBackMethod"
                  >
                    <el-select
                      v-model="dialogAddEditForm.callBackMethod"
                      filterable
                      clearable
                      placeholder="请选择回访方式"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in methodOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="回访结果"
                    prop="callBackResult"
                  >
                    <el-select
                      v-model="dialogAddEditForm.callBackResult"
                      filterable
                      clearable
                      placeholder="请选择回访结果"
                      style="width:100%"
                      @change="changeResultFun"
                    >
                      <el-option
                        v-for="item in resultOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="处理意见"
                    prop="dealOpinion"
                  >
                    <el-input
                      v-model="dialogAddEditForm.dealOpinion"
                      rows="3"
                      type="textarea"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div
              class="modal-row-box"
              style="padding-bottom:10px;"
            >
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 数据请求
import { getUserId, getUserName } from '@/utils/auth'
import { loadCurrentDateApi } from '@/api/common'
import { loadDictDataApi } from '@/api/dict'
import { saveOrUpdateCallBackBillApi, initCallBackBillApi } from '@/api/callBackBill'
export default {
  components: { },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    selectObject: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: true,
      loadingText: '努力加载数据中，请耐心等待',
      dialogAddEditForm: {
        provinceName: '',
        cityName: '',
        storeName: '',
        linkman: '',
        phone: '',
        schemeName: '',
        schemeNo: '',
        materialsOperater: '',
        issueDate: '',
        materialsName: '',
        unitName: '',
        amount: '',
        callBackUserName: '',
        callBackUserId: '',
        callBackDate: '',
        callBackMethod: 1,
        callBackResult: '',
        dealOpinion: '',
        remark: ''
      },
      dialogAddEditFormRules: {
        callBackDate: [ { required: true, message: '请选择回访时间', trigger: 'change' }],
        callBackMethod: [ { required: true, message: '请选择回访方式', trigger: 'change' }],
        callBackResult: [ { required: true, message: '请选择回访结果', trigger: 'change' }],
        dealOpinion: [ { required: false, message: '请输入处理意见', trigger: 'blur' }, { max: 256, message: '最多输入256个字符', trigger: 'blur' }],
        remark: [{ max: 512, message: '最多输入512个字符', trigger: 'blur' } ]
      },
      methodOptions: [],
      resultOptions: []
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditForm.clearValidate()
        })
        this.loading = true
        this.loadingText = '努力加载数据中，请耐心等待'
        this.dialogAddEditForm = {
          provinceName: '',
          cityName: '',
          storeName: '',
          linkman: '',
          phone: '',
          schemeName: '',
          schemeNo: '',
          materialsOperater: '',
          issueDate: '',
          materialsName: '',
          unitName: '',
          amount: '',
          callBackUserName: '',
          callBackUserId: '',
          callBackDate: '',
          callBackMethod: 1,
          callBackResult: 1,
          dealOpinion: '',
          remark: ''
        }
        this.methodOptions = []
        this.resultOptions = []
        this.initCallBackMethodSelectData()
        this.initCallBackResultSelectData()
        if (this.eventType === 'add') {
          this.dialogAddEditForm.provinceName = this.selectObject.provinceName
          this.dialogAddEditForm.cityName = this.selectObject.cityName
          this.dialogAddEditForm.storeName = this.selectObject.storeName
          this.dialogAddEditForm.linkman = this.selectObject.ownerName
          this.dialogAddEditForm.phone = this.selectObject.phone
          this.dialogAddEditForm.schemeNo = this.selectObject.schemeNo
          this.dialogAddEditForm.schemeName = this.selectObject.schemeName
          this.dialogAddEditForm.materialsOperater = this.selectObject.receiver
          this.dialogAddEditForm.issueDate = this.selectObject.visitDateStr
          this.dialogAddEditForm.materialsName = this.selectObject.materialsName
          this.dialogAddEditForm.unitName = this.selectObject.unitName
          this.dialogAddEditForm.amount = this.selectObject.amount
          this.dialogAddEditForm.sort = this.selectObject.sort
          this.dialogAddEditForm.billId = this.selectObject.billId
          this.dialogAddEditForm.itemId = this.selectObject.itemId
          this.dialogAddEditForm.callBackUserName = getUserName()
          this.dialogAddEditForm.callBackUserId = getUserId()
          loadCurrentDateApi().then(res => {
            this.dialogAddEditForm.callBackDate = res.data ? res.data : ''
            this.loading = false
          })
        } else {
          this.initPageData()
        }
      }
    }
  },
  methods: {
    // 加载数据
    initPageData () {
      initCallBackBillApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditForm){
          if (key !== 'callBackDate') {
            this.dialogAddEditForm[key] = data[key]
          }
        }
        this.dialogAddEditForm.callBackDate = data.callBackDateStr
        this.dialogAddEditForm.id = data.id
        this.loading = false
      })
    },
    // 初始回访方式下拉数据
    initCallBackMethodSelectData(){
      loadDictDataApi({ type: 39 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.methodOptions.push({ label: item.optionLable, data: item.optionValue })
        })
      })
    },
    // 初始回访结果下拉数据
    initCallBackResultSelectData(){
      loadDictDataApi({ type: 40 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.resultOptions.push({ label: item.optionLable, data: item.optionValue })
        })
      })
    },
    // 回访结果回调
    changeResultFun(val){
      if (val !== 1) {
        this.dialogAddEditFormRules.dealOpinion[0].required = true
      } else {
        this.dialogAddEditFormRules.dealOpinion[0].required = false
      }
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditForm.validate(valid => {
        if (valid) {
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '回访记录','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.loadingText = '正在处理数据中，请耐心等待'
              this.saveOrUpdate()
            })
            .catch(() => { })
        }
      })
    },
    // 保存操作
    saveOrUpdate () {
      saveOrUpdateCallBackBillApi(this.dialogAddEditForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
